import { CheckAuth } from 'auth/auth';
import { useGetClientAdminDashboardSummaryQuery } from 'redux_store/services/admin/pipeline';
import {
  useGetLoanOfficerDashboardSummaryQuery,
  useGetLoanProcessorDashboardSummaryQuery,
} from 'redux_store/services/officer/pipeline';
import { useGetPipelineStatusQuery } from 'redux_store/services/client/pipeline';

const B2BDataPreloader = ({ children }) => {
  const cachedUser = CheckAuth() || {};
  const currentRole = String(cachedUser.role || cachedUser.originalRole || '')
    .trim()
    .toLowerCase();

  const isAdmin =
    currentRole === 'client_admin' || currentRole.includes('client') ||
    currentRole.includes('org') || currentRole === 'admin' ||
    currentRole === 'branch_admin' || currentRole.includes('branch') ||
    currentRole.includes('platform');
  const isLoanOfficer = currentRole === 'loan_officer';
  const isLoanProcessor = currentRole === 'loan_processor';

  // Background prefetch — dashboard summary (role-aware)
  useGetClientAdminDashboardSummaryQuery(undefined, { skip: !isAdmin });
  useGetLoanOfficerDashboardSummaryQuery(undefined, { skip: !isLoanOfficer });
  useGetLoanProcessorDashboardSummaryQuery(undefined, { skip: !isLoanProcessor });

  // Pipeline status — used by all B2B dashboard pages
  useGetPipelineStatusQuery({}, { skip: false });

  return children;
};

export default B2BDataPreloader;
